export enum DMS_PROVIDER_TYPE {
    Default = 'Default',
    SharePoint = 'SharePoint',
    IManage = 'iManage',
    Active = 'Active'
}